// extracted by mini-css-extract-plugin
export default {"root":"SortDrawing_root__n87j+","buttons":"SortDrawing_buttons__dBoFQ","closeButton":"SortDrawing_closeButton__a47PG"};